import * as React from 'react';

import { useFiltersContext } from '../../../../packages/Filters/shared/utils/useFiltersContext';
import { EStarRating, getTermsValue, NonEmptyArray } from '../../../../packages/JsonQuery';
import { ETestId } from '../../../common/constants';
import { FilterModal } from '../../components/FilterModal/FilterModal';
import { StarRatingOptions } from '../../components/StarRatingOptions';

interface IStarRatingModalContainerProps {
  onResetClick(): void;
  onApplyClick(): void;
  onClose(): void;
}

export const StarRatingModalContainer = ({ onResetClick, onApplyClick, onClose }: IStarRatingModalContainerProps) => {
  const { jsonQuery, onChange } = useFiltersContext();
  const starRating = getTermsValue('star_rating')(jsonQuery);

  const handleChange = React.useCallback(
    (value: EStarRating, checked: boolean) => {
      let newStarRating: NonEmptyArray<EStarRating> | null;

      if (checked) {
        newStarRating = [...(starRating || []), value];
      } else {
        const filteredValue = starRating?.filter(i => i !== value);
        newStarRating = filteredValue?.length ? (filteredValue as NonEmptyArray<EStarRating>) : null;
      }

      onChange({ action: 'setStarRating', arguments: [newStarRating] });
    },
    [starRating],
  );

  return (
    <FilterModal
      title="Количество звёзд"
      onResetClick={onResetClick}
      onApplyClick={onApplyClick}
      onClose={onClose}
      contentTestId={ETestId.RedesignedFiltersStarRatingModal}
    >
      <StarRatingOptions value={starRating} onChange={handleChange} />
    </FilterModal>
  );
};
